import type { FunctionalComponent } from 'preact';
import { useState } from 'preact/hooks';
import { useStore } from '../store';
import type { FAQItem } from '../types';

/** Collapsible FAQ section — uses theme CSS variables */
export const FAQ: FunctionalComponent = () => {
  const { state } = useStore();
  const event = state.event;
  const [expandedIndex, setExpandedIndex] = useState<number | null>(null);

  const faq = Array.isArray(event?.faq) ? event.faq : [];
  if (faq.length === 0) return null;

  return (
    <div class="mw-faq">
      <div class="mw-faq-title">Frequently Asked Questions</div>
      <div class="mw-faq-list">
        {faq.map((item: FAQItem, idx: number) => (
          <div
            key={idx}
            class={`mw-faq-item ${expandedIndex === idx ? 'mw-faq-item--expanded' : ''}`}
          >
            <button
              type="button"
              class="mw-faq-question"
              onClick={() => setExpandedIndex(prev => (prev === idx ? null : idx))}
              aria-expanded={expandedIndex === idx}
            >
              <span class="mw-faq-question-text">{item.question}</span>
              <span class="mw-faq-chevron">{expandedIndex === idx ? '−' : '+'}</span>
            </button>
            {expandedIndex === idx && (
              <div class="mw-faq-answer">{item.answer}</div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};
